/**
 * Spanish translations
 */

export default {
  'Not included': 'No incluido',
  Included: 'Incluido',
  Refresh: 'Actualizar',
  Unlimited: 'Ilimitado',
  'Pricing plans': 'Planes de precios',
  'Select an option': 'Seleccione una opción',
  'Play video': 'Reproducir video',
  'Pause video': 'Pausar video',
  // Add more translations here
}
